const services = [
  {
    icon: 'ri-flashlight-line',
    color: 'bg-yellow-50 text-yellow-600',
    title: 'Installations Électriques',
    href: '/electricite',
    items: [
      'Tableaux électriques & NIBT/OIBT',
      'Bornes de recharge VE (Wallbox 22 kW)',
      'Dépannage urgence 24/7',
      'Rénovation complète appartements',
      'Domotique KNX & Philips Hue',
    ],
  },
  {
    icon: 'ri-fire-line',
    color: 'bg-orange-50 text-orange-600',
    title: 'Pompes à Chaleur & Chauffage',
    href: '/pompes-chaleur',
    items: [
      'PAC air/eau & géothermique',
      'Remplacement chaudières mazout/gaz',
      'Subventions cantonales jusqu\'à CHF 10\'000',
      'Marques ELCO, Viessmann, Daikin',
      'Bilan énergétique & conseil',
    ],
  },
  {
    icon: 'ri-drop-line',
    color: 'bg-blue-50 text-blue-600',
    title: 'Plomberie & Sanitaire',
    href: '/sanitaire',
    items: [
      'Urgences fuites & dégâts des eaux',
      'Installation salles de bain complètes',
      'Douches italiennes & baignoires',
      'Marques Geberit, Hansgrohe, Grohe',
      'Rénovation sanitaire clé en main',
    ],
  },
  {
    icon: 'ri-windy-line',
    color: 'bg-teal-50 text-teal-600',
    title: 'Ventilation & Climatisation',
    href: '/ventilation',
    items: [
      'VMC double flux Zehnder & Helios',
      'Climatisation réversible multi-split',
      'Entretien & maintenance VMC',
      'Qualité de l\'air intérieur (IAQ)',
      'Conformité normes SIA 382',
    ],
  },
  {
    icon: 'ri-home-wifi-line',
    color: 'bg-violet-50 text-violet-600',
    title: 'Domotique & Maison Connectée',
    href: '/domotique',
    items: [
      'Systèmes KNX & Loxone',
      'Éclairage intelligent Philips Hue',
      'Volets, stores & contrôle d\'accès',
      'Sécurité & alarmes connectées',
      'Intégration Apple HomeKit / Google Home',
    ],
  },
  {
    icon: 'ri-tools-line',
    color: 'bg-red-50 text-red-600',
    title: 'Maintenance & Urgences 24/7',
    href: '/maintenance',
    items: [
      'Intervention en 30 à 90 minutes',
      'Pannes électriques, eau, chauffage',
      'Contrats maintenance préventive',
      'Gestion régies & copropriétés',
      'Diagnostic complet installations',
    ],
  },
  {
    icon: 'ri-building-2-line',
    color: 'bg-gray-100 text-gray-600',
    title: 'Entreprise Générale',
    href: '/entreprise-generale',
    items: [
      'Coordination tous corps de métier',
      'Rénovation complète & transformation',
      'Gestion de projet clé en main',
      'Suivi chantier & contrôle qualité',
      'Devis détaillé & planning précis',
    ],
  },
  {
    icon: 'ri-brush-line',
    color: 'bg-green-50 text-green-600',
    title: 'Nettoyage & Conciergerie',
    href: '/nettoyage-conciergerie',
    items: [
      'Nettoyage fin de chantier',
      'Entretien régulier bureaux & immeubles',
      'Nettoyage de vitres & façades',
      'Conciergerie & gestion des parties communes',
      'Débarras & évacuation de déchets',
    ],
  },
];

export default function PresentationServices() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-brand-500 mb-3">Nos prestations</span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">
            Un seul interlocuteur,<br />toutes les compétences
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            CasaReNovaPlus regroupe l'ensemble des corps de métier du bâtiment sous un même toit. Rénovation, électricité, plomberie, chauffage, ventilation, domotique — nous gérons tout.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <a
              key={service.title}
              href={service.href}
              className="group bg-white border border-gray-100 rounded-2xl p-6 hover:border-brand-200 hover:bg-brand-50/30 transition-all cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${service.color}`}>
                <i className={`${service.icon} text-xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-3 group-hover:text-brand-600 transition-colors">
                {service.title}
              </h3>
              <ul className="space-y-1.5">
                {service.items.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-xs text-gray-500">
                    <i className="ri-check-line text-brand-500 mt-0.5 shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-4 flex items-center gap-1 text-xs font-semibold text-brand-500 group-hover:gap-2 transition-all">
                En savoir plus <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
